import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';
import { METRICS, getMetrics } from '@/models/metrics.enum';
import {
  baseQueryParamMapping,
  defaultReportingPeriod,
} from '@/components/core/analytics/queryParamMapping';
import { searchBrandMediaTypes } from '@/app/library/constants';

export const useYourPosts = () => {
  const metrics = getMetrics('yourPosts');

  return {
    title: 'Threads Posts',
    channelFilterKey: 'threads',
    filters: {
      brandMediaTypes: [searchBrandMediaTypes.THREADS_OWNED],
      default: {
        captionContain: [],
        captionNotContain: [],
        contentTags: [],
        contentTagMatchType: 'ANY',
        postType: [],
        reportingPeriod: defaultReportingPeriod,
        sort: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
      options: {
        postType: [
          { label: 'Text', value: 'TEXT_POST' },
          { label: 'Image', value: 'IMAGE' },
          { label: 'Video', value: 'VIDEO' },
          { label: 'Carousel', value: 'CAROUSEL_ALBUM' },
          { label: 'Audio', value: 'AUDIO' },
        ],
      },
      queryParamMapping: {
        ...baseQueryParamMapping,
        postType: { queryParamName: 'postType', type: 'array', elementType: 'string' },
        captionContain: {
          queryParamName: 'captionContain',
          type: 'array',
          elementType: 'string',
        },
        captionNotContain: {
          queryParamName: 'captionNotContain',
          type: 'array',
          elementType: 'string',
        },
      },
      scope: 'threadsYourPosts',
      sortDetails: {
        options: [
          { label: 'Recently Published', value: 'DATE' },
          {
            title: 'Organic',
            children: metrics.all([
              METRICS.THREADS.VIEWS,
              METRICS.THREADS.ENGAGEMENTS,
              METRICS.THREADS.ENGAGEMENT_RATE,
              METRICS.THREADS.LIKES,
              METRICS.THREADS.QUOTES,
              METRICS.THREADS.REPLIES,
              METRICS.THREADS.REPOSTS,
              METRICS.THREADS.REPOSTS_AND_QUOTES,
              METRICS.THREADS.SHARES,
            ]),
          },
        ],
        default: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
    },
    displayMetrics: metrics.all([
      METRICS.THREADS.ENGAGEMENTS,
      METRICS.THREADS.ENGAGEMENT_RATE,
      METRICS.THREADS.VIEWS,
      METRICS.THREADS.REPLIES,
    ]),
    metricLabels: metrics.all(Object.values(METRICS.THREADS)),
    download: {
      pdf: {
        fileName: 'yourThreadsPostsPDF',
        type: 'threadsYourPosts',
        label: 'Your Threads Posts PDF',
        pendingKey: 'threadsYourPostsReportPending',
      },
      csv: {
        fileName: 'yourThreadsPostsCSV',
        type: 'threadsYourPosts',
        label: 'Your Threads Posts CSV',
        pendingKey: 'threadsYourPostsCSVPending',
      },
    },
    platformConnection: PLATFORM_CONNECTION.THREADS,
  };
};
